// import external dependencies
import { documentReady } from './util/dom';

/**
 * include this to load Modernizr
 * also uncomment prebuild modernizr line in package.json
 * (modernizr.js file generated on build)
 */
import Modernizr from './modernizr';

// Import everything from autoload
import './autoload/_accordion.js'; import './autoload/_bootstrap.js'; import './autoload/_nav.js'; import './autoload/_sidebar.js'; import './autoload/_slider.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
// import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  // aboutUs,
});

// Load Events
documentReady(() => routes.loadEvents());
